import { RenderPipeline } from "three/webgpu";
import { pass } from "three/tsl";
import { bloom } from "three/addons/tsl/display/BloomNode.js";

export default class PostProcess {
  constructor(renderer, scene, camera) {
    this.renderer = renderer;

    const scenePass = pass(scene, camera);
    const colorTex = scenePass.getTextureNode("output");
    this.bloomPass = bloom(colorTex, 0.8, 0.7, 1.0);

    this.pipeline = new RenderPipeline(renderer);
    this.pipeline.outputNode = colorTex.add(this.bloomPass);
  }

  render() {
    this.pipeline.render();
  }
}
